import { useEffect } from "react";

function HomeScreen() {
  useEffect(() => {
    window.location.href = "https://donut.app";
  }, []);

  return null;
}

export default HomeScreen;